import api from '../../api/axios';
import { showError } from '../../Components/reuse/Toast';

// Action Types
export const GET_CONVERSATIONS_REQUEST = 'GET_CONVERSATIONS_REQUEST';
export const GET_CONVERSATIONS_SUCCESS = 'GET_CONVERSATIONS_SUCCESS';
export const GET_CONVERSATIONS_FAILURE = 'GET_CONVERSATIONS_FAILURE';

// New: Conversation list (page/limit) types
export const GET_CONVERSATION_LIST_REQUEST = 'GET_CONVERSATION_LIST_REQUEST';
export const GET_CONVERSATION_LIST_SUCCESS = 'GET_CONVERSATION_LIST_SUCCESS';
export const GET_CONVERSATION_LIST_FAILURE = 'GET_CONVERSATION_LIST_FAILURE';

export const GET_CONVERSATION_DETAILS_REQUEST = 'GET_CONVERSATION_DETAILS_REQUEST';
export const GET_CONVERSATION_DETAILS_SUCCESS = 'GET_CONVERSATION_DETAILS_SUCCESS';
export const GET_CONVERSATION_DETAILS_FAILURE = 'GET_CONVERSATION_DETAILS_FAILURE';

// Admin conversations types
export const GET_ADMIN_CONVERSATIONS_REQUEST = 'GET_ADMIN_CONVERSATIONS_REQUEST';
export const GET_ADMIN_CONVERSATIONS_SUCCESS = 'GET_ADMIN_CONVERSATIONS_SUCCESS';
export const GET_ADMIN_CONVERSATIONS_FAILURE = 'GET_ADMIN_CONVERSATIONS_FAILURE';

// Get conversations
export const getConversations = (agentId, limit = 10, nextCursor = null) => async (dispatch) => {
  const append = Boolean(nextCursor);
  dispatch({ type: GET_CONVERSATIONS_REQUEST, meta: { append } });
  try {
    const payload = {
      agentId: agentId,
      limit: limit
    };
    
    if (nextCursor) {
      payload.nextCursor = nextCursor;
    }

    const response = await api.post('conversations/getConversations', payload);
    if (response.data.success) {
      dispatch({ type: GET_CONVERSATIONS_SUCCESS, payload: response.data, meta: { append } });
    } else {
      dispatch({ type: GET_CONVERSATIONS_FAILURE, error: response.data.message || 'Failed to fetch conversations', meta: { append } });
      showError(response.data.message || 'Failed to fetch conversations');
    }
  } catch (error) {
    console.error('Failed to fetch conversations:', error);
    dispatch({ type: GET_CONVERSATIONS_FAILURE, error: 'Failed to fetch conversations', meta: { append } });
    showError('Failed to fetch conversations');
  }
};

// New: Get conversations via page/limit list API
export const getConversationList = (limit = 50, page = 1, userId, filters = {}) => async (dispatch) => {
  const append = page > 1;
  dispatch({ type: GET_CONVERSATION_LIST_REQUEST, meta: { append } });
  try {
    // Build request body with filters only (no page/limit)
    const body = {
      userId: userId || undefined,
      ...filters
    };

    // Convert date objects to ISO strings if they exist
    if (filters.fromDate) {
      body.fromDate = filters.fromDate instanceof Date ? filters.fromDate.toISOString() : filters.fromDate;
    }
    if (filters.toDate) {
      body.toDate = filters.toDate instanceof Date ? filters.toDate.toISOString() : filters.toDate;
    }

    // Send page and limit as query parameters
    const response = await api.post(`conversation/getConversationList?page=${page}&limit=${limit}`, body);
    const success = response?.data?.success === undefined ? true : response.data.success;
    if (success) {
      dispatch({ type: GET_CONVERSATION_LIST_SUCCESS, payload: response.data, meta: { append, limit, page } });
    } else {
      const message = response?.data?.message || 'Failed to fetch conversation list';
      dispatch({ type: GET_CONVERSATION_LIST_FAILURE, error: message, meta: { append } });
      showError(message);
    }
  } catch (error) {
    console.error('Failed to fetch conversation list:', error);
    dispatch({ type: GET_CONVERSATION_LIST_FAILURE, error: 'Failed to fetch conversation list', meta: { append } });
    showError(error.response.data.message || 'Failed to fetch conversation list');
  }
};

// Get conversation details
export const getConversationDetails = (conversationId, userId) => async (dispatch) => {
  dispatch({ type: GET_CONVERSATION_DETAILS_REQUEST });
  try {
    const payload = {
      conversationId: conversationId,
      userId: userId || undefined,
    };

    const response = await api.post('conversation/getConversationDetails', payload);
    if (response.data.success) {
      dispatch({ type: GET_CONVERSATION_DETAILS_SUCCESS, payload: response.data.data });
    } else {
      dispatch({ type: GET_CONVERSATION_DETAILS_FAILURE, error: response.data.message || 'Failed to fetch conversation details' });
      showError(response.data.message || 'Failed to fetch conversation details');
    }
  } catch (error) {
    console.error('Failed to fetch conversation details:', error);
    dispatch({ type: GET_CONVERSATION_DETAILS_FAILURE, error: 'Failed to fetch conversation details' });
    showError(error.response.data.message || 'Failed to fetch conversation details');
  }
};

// Get all conversations by admin
export const getAllConversationListByAdmin = (page = 1, limit = 20, filters = {}) => async (dispatch) => {
  dispatch({ type: GET_ADMIN_CONVERSATIONS_REQUEST });
  try {
    const body = {
      userId: filters.userId || undefined,
      fromDate: filters.fromDate || undefined,
      toDate: filters.toDate || undefined,
      call_summary_title: filters.call_summary_title || undefined,
      call_successful: filters.call_successful || undefined,
      convoId: filters.convoId || undefined,
      type: filters.type || undefined,
      searchKeyword: filters.searchKeyword || undefined,
      customerEmail: filters.customerEmail || undefined,
    };

    // Convert date objects to ISO strings if they exist
    if (filters.fromDate) {
      body.fromDate = filters.fromDate instanceof Date ? filters.fromDate.toISOString() : filters.fromDate;
    }
    if (filters.toDate) {
      body.toDate = filters.toDate instanceof Date ? filters.toDate.toISOString() : filters.toDate;
    }

    const response = await api.post(`conversation/getAllConversationListByAdmin?page=${page}&limit=${limit}`, body);
    const success = response?.data?.success === undefined ? true : response.data.success;
    if (success) {
      dispatch({ type: GET_ADMIN_CONVERSATIONS_SUCCESS, payload: response.data, meta: { page, limit } });
    } else {
      const message = response?.data?.message || 'Failed to fetch admin conversations';
      dispatch({ type: GET_ADMIN_CONVERSATIONS_FAILURE, error: message });
      showError(message);
    }
  } catch (error) {
    console.error('Failed to fetch admin conversations:', error);
    dispatch({ type: GET_ADMIN_CONVERSATIONS_FAILURE, error: 'Failed to fetch admin conversations' });
    showError(error.response?.data?.message || 'Failed to fetch admin conversations');
  }
};
